<template>
  <drag-wrap
    v-if="compVisible"
    :visible="compVisible"
    modalId="screen-capture-sources"
    modalName="屏幕共享选择"
  >
    <div class="comp-container__screen">
      <div class="roster-drawer__title">
        <div class="title">选择共享窗口</div>
        <div class="close" @click="onClickClose">
          <img src="@saas/pages/assets/images/live/close-1.png" alt="" />
        </div>
      </div>
      <div class="roster-drawer__content can-not-drag-wrap">
        <div class="type-list-box">
          <div
            v-show="canScrollLeft"
            class="arrow-left arrow"
            @click="handleShowMore('left')"
          >
            <img src="@saas/pages/assets/images/live/arrow_left.png" alt="" />
          </div>
          <div class="type-list" ref="typeList" @scroll="handleScroll">
            <div class="list-scroll-box" ref="typeScrollList">
              <div
                class="list-item"
                :class="{
                  selected: currentType.appId === item.appId,
                }"
                v-for="(item, index) in typeList"
                :key="index"
                @click="handleClickType(item)"
              >
                <render-canvas
                  v-if="item.appId !== 'all'"
                  class="icon"
                  :buffer="item.iconBGRA.buffer"
                  :width="item.iconBGRA.width"
                  :height="item.iconBGRA.height"
                ></render-canvas>
                <div class="icon all" v-else>全部</div>
              </div>
            </div>
          </div>
          <div
            v-show="canScrollRight"
            class="arrow-right arrow"
            @click="handleShowMore('right')"
          >
            <img src="@saas/pages/assets/images/live/arrow_right.png" alt="" />
          </div>
        </div>
        <div class="win-list" ref="winList">
          <div
            class="list-item"
            :class="{
              selected: currentWin.sourceId === item.sourceId,
            }"
            v-for="item in winList"
            :key="item.sourceId"
            @click="handleClickScreen(item)"
          >
            <div class="thumb-box">
              <render-canvas
                class="thumb"
                :buffer="item.thumbBGRA.buffer"
                :width="item.thumbBGRA.width"
                :height="item.thumbBGRA.height"
              ></render-canvas>
              <div class="hover-mask">点击开始共享</div>
            </div>
            <div class="name ellipsis">{{ item.sourceName }}</div>
            <render-canvas
              v-if="item.iconBGRA && item.iconBGRA.width"
              class="icon"
              :buffer="item.iconBGRA.buffer"
              :width="item.iconBGRA.width"
              :height="item.iconBGRA.height"
            ></render-canvas>
          </div>
          <div class="list-item empty"></div>
          <div class="list-item empty"></div>
          <div class="list-item empty"></div>
        </div>
        <div class="select-option">
          <el-checkbox v-model="pcAudio">共享电脑音频</el-checkbox>
          <el-tooltip
            effect="dark"
            content="需要开启白板权限"
            placement="top"
            :disabled="canUseShareToolbar"
          >
            <span class="toolbar-checkbox-hit-area">
              <el-checkbox v-model="toolBar" :disabled="!canUseShareToolbar">
                展示工具栏
              </el-checkbox>
            </span>
          </el-tooltip>
        </div>
        <div class="loading" v-if="loading">
          <img src="@saas/pages/assets/images/chat/loading.png" alt="" />
        </div>
      </div>
    </div>
  </drag-wrap>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { DragWrap } from "@saas/components";
import { uploadLiveLog } from "@saas/components/src/utils/log";
import RenderCanvas from "../components/RenderCanvas.vue";
import screenShare from "../mixins/screen-share";
export default {
  mixins: [screenShare],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DragWrap,
    RenderCanvas,
  },
  data() {
    return {
      compVisible: false,
      // 所有可共享窗口 包含桌面和窗口
      allList: [],
      // 所有的桌面
      desktopList: [],
      // 根据程序划分
      typeList: [],
      winList: [],
      pcAudio: true,
      toolBar: true,
      currentType: {},
      currentWin: {},
      canScroll: false,
      canScrollLeft: false,
      canScrollRight: false,
      typeWidth: 40, //一个类型的宽度px
      loading: false,
      atScreen: null, // 共享的窗口所处的屏幕
      getScreenCaptureSourcesTimer: null,
      timer: null,
    };
  },
  watch: {
    visible(val) {
      this.compVisible = val;
      if (val && this.liveService) {
        this.loading = true;
        if (!this.canUseShareToolbar) {
          this.toolBar = false;
        }
        this.allList = [];
        this.typeList = [];
        this.desktopList = [];
        this.winList = [];
        clearTimeout(this.getScreenCaptureSourcesTimer);

        if (window.LiveElectronApi?.openHelperWindow) {
          window.LiveElectronApi.openHelperWindow().then(() => {
            if (this.compVisible) {
              this.getScreenCaptureSources();
            }
          });
        } else {
          this.getScreenCaptureSourcesTimer = setTimeout(() => {
            this.getScreenCaptureSources();
          }, 100);
        }
      }
    },
  },
  mounted() {
    if (window.ipcRenderer) {
      window.ipcRenderer.on("new-chat", this.excludedShareChatWindow);
    }
  },
  beforeDestroy() {
    clearTimeout(this.getScreenCaptureSourcesTimer);
    clearTimeout(this.timer);
    if (window.ipcRenderer) {
      window.ipcRenderer.removeListener(
        "new-chat",
        this.excludedShareChatWindow
      );
    }
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "imService",
      "whiteBoardService",
      "screenShareStatus",
      "remoteScreenShareInfo",
      "screenShareBoardId",
      "microphoneList",
      "currentMicDevice",
      "userStatus",
    ]),
    ...mapState("newChat", ["showChat", "chatMode"]),
    isScreenShare() {
      return ["start", "pause"].includes(this.screenShareStatus);
    },
    userInfo() {
      return this.$store.getters.user || {};
    },
    // 是否在接收共享（）
    isScreenShareRemote() {
      return ["start", "pause"].includes(this.remoteScreenShareInfo.status);
    },
    canUseShareToolbar() {
      return this.userStatus?.is_whiteboard === 1;
    },
  },
  methods: {
    ...mapMutations("live", [
      "setScreenSharePreInfo",
      "setScreenShareStatus",
      "setShowScreenShareDialog",
      "setScreenShareBoardId",
      "setCurrentMicDevice",
    ]),
    ...mapMutations("newChat", ["SET_CHAT_MODE", "SET_SHOW_CHAT"]),
    isMac() {
      return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    },
    open() {
      this.compVisible = true;
      this.$nextTick(() => {
        this.getScreenCaptureSources();
      });
    },
    onClickClose() {
      // 关闭helperwindow
      if (window.LiveElectronApi) {
        window.LiveElectronApi.closeHelperWin?.();
        window.LiveElectronApi.setVisibleOnAllWorkspaces?.(false);
      }
      this.handleClose();
    },
    handleClose() {
      this.setShowScreenShareDialog(false);
      this.compVisible = false;
      this.$emit("update:visible", false);
    },
    // 获取可分享的屏幕
    getScreenCaptureSources() {
      console.time("djj_time");
      console.log("screen_log_init");
      const isMac = this.isMac();
      console.log("isMac__", isMac);
      const list = this.liveService.getScreenCaptureSources({
        thumbHeight: isMac ? 90 : 90,
        thumbWidth: isMac ? 160 : 160,
        iconHeight: isMac ? 48 : 24,
        iconWidth: isMac ? 48 : 24,
      });
      console.log("screen_share__screen_log_list", list);
      // 判断平台
      list.forEach((element) => {
        if (isMac) {
          // mac: 用正则提取 id
          const regex = /\((\d+)\)$/;
          const match = element.sourceName.match(regex);
          const number = match ? match[1] : element.sourceId;
          element.appId = number;
        } else {
          // windows: 用 '-' 分割，取最后一段
          const parts = element.sourceName.split("-");
          element.appId =
            parts.length >= 1
              ? parts[parts.length - 1].trim()
              : element.sourceId;
        }
      });
      this.allList = list;
      this.desktopList = list.filter((item) => item.type === 1);
      const allWinList = list.filter((item) => item.type != 1);
      this.getAppList(allWinList);
      this.getWindowList("all");
      this.currentType = this.typeList[0];
      console.timeEnd("djj_time");
      this.loading = false;
    },
    // 获取程序列表
    getAppList(allWinList) {
      this.typeList = [
        {
          appId: "all",
        },
      ];
      allWinList.forEach((item) => {
        if (!this.typeList.some((sItem) => sItem.appId === item.appId)) {
          this.typeList.push({
            appId: item.appId,
            iconBGRA: item.iconBGRA,
          });
        }
      });
      this.$nextTick(() => {
        // 检查是否需要显示左右箭头
        const scrollListdom = this.$refs.typeScrollList;
        const typeListdom = this.$refs.typeList;
        // 检查是否需要显示左右箭头
        this.canScrollRight =
          scrollListdom.clientWidth > typeListdom.clientWidth;
      });
    },
    // 获取程序下的窗口
    getWindowList(appId) {
      if (appId === "all") {
        this.winList = [...this.allList];
      } else {
        this.winList = this.allList.filter((item) => item.appId === appId);
      }
    },
    handleClickType(item) {
      console.log("screen_log_item", item);
      this.currentType = item;
      this.getWindowList(item.appId);
    },
    async handleClickScreen(source) {
      if (this.isScreenShareRemote) {
        this.$darkMessage.error("其他老师正在共享，此时无法发起共享");
        return;
      }
      const canSharePcAudio = await this.ensureSystemAudioLoopbackReady(source);
      // 判断当前是否正在共享（有可能处在暂停，有可能处在共享中）
      if (this.isScreenShare) {
        this.uploadScreenShareAudioLog("screen_share_switch_before_audio", {
          source,
        });
        // 停止共享音频
        this.liveService.stopSystemAudioLoopback();
        if (canSharePcAudio) {
          this.liveService.startSystemAudioLoopback();
        }
        if (this.toolBar) {
          this.resetScreenShareBoard();
        }
        // 正在共享
        this.currentWin = source;
        console.log("新共享的窗口————", source);
        // 选择共享窗口
        this.liveService.selectScreenCaptureTarget({
          source: source,
          borderColor: 0x23c343,
          borderWidth: 8,
        });
        // 设置窗口位置
        this.setPosition(source);
        if (this.screenShareStatus === "pause") {
          this.liveService.resumeScreenCapture();
        }
        // 设置共享状态为开始
        this.setScreenShareStatus("start");
        // 关闭弹窗
        this.handleClose();
        window.LiveElectronApi.setResizable(true);
        // 最大化
        window.LiveElectronApi.maxSizeWin();
        window.LiveElectronApi.setResizable(false);
        // 设置窗口点击穿透
        window.LiveElectronApi.setIgnoreMouseEvents(true);
        this.setScreenSharePreInfo({
          source: source,
          isAudio: canSharePcAudio,
          isWhiteboard: this.toolBar,
        });
        this.uploadScreenShareAudioLog("screen_share_switch_after_pre_info", {
          source,
        });
        this.imService.sendMGLiveRoomCustomMsg({
          cmdId: 2,
          data: {
            type: "screenShare",
            data: {
              status: this.screenShareStatus, // start 开始共享， pause 暂停共享 end 结束共享
              from: "desktop", // web网页端 desktop 桌面端
              isWhiteboard: this.toolBar,
              isPcAudio: canSharePcAudio,
            },
          },
        });
      } else {
        if (this.showChat && this.chatMode === "embed") {
          this.SET_SHOW_CHAT(false);
        }
        this.currentWin = source;
        console.log("共享的窗口————", source);
        // 选择共享窗口
        this.liveService.selectScreenCaptureTarget({
          source: source,
          borderColor: 0x23c343,
          borderWidth: 8,
        });
        // 获取当前窗口大小
        const size = window.LiveElectronApi.getWindowSize();
        // 获取当前窗口的位置
        const position = window.LiveElectronApi.getPosition();
        console.log("size", size);
        console.log("position", position);
        // 存储当前的位置和大小信息
        this.setScreenSharePreInfo({
          size,
          position,
          isAudio: canSharePcAudio,
          isWhiteboard: this.toolBar,
          currentBoardId: this.whiteBoardService.getCurrentBoard(),
          source: source,
        });
        // 设置窗口位置
        this.setPosition(source);
        // 最大化
        window.LiveElectronApi.maxSizeWin();
        // 如果共享音频
        if (canSharePcAudio) {
          this.uploadScreenShareAudioLog("screen_share_start_pc_audio", {
            source,
          });
          this.liveService.startSystemAudioLoopback();
        }
        // 如果显示工具栏
        if (this.toolBar) {
          this.createWhiteGroup();
        }
        // 设置窗口点击穿透
        window.LiveElectronApi.setIgnoreMouseEvents(true);
        // 设置窗口禁止拖拽改变大小
        window.LiveElectronApi.setResizable(false);
        // 当前窗口固定在最顶部
        window.LiveElectronApi.toggleOnTop(true);
        // 设置共享状态为开始
        this.setScreenShareStatus("start");
        // 关闭弹窗
        this.handleClose();
        // 不共享当前应用窗口
        this.excludedShareWindow();
        // 不同项聊天敞口
        this.excludedShareChatWindow();
        window.ipcRenderer.send("get-all-system-windows", source);
        // 开始共享
        this.liveService.startScreenCapture({
          view: null,
        });
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        this.uploadScreenShareAudioLog("screen_share_audio_timer", {
          source,
        });
        if (this.toolBar) {
          this.startSetIgnoreMouseEventsSync(source);
        }
      }, 1000);
    },
    async ensureSystemAudioLoopbackReady(source) {
      if (!this.pcAudio) {
        return false;
      }
      const microphoneList = await this.getAvailableMicrophoneList(source);
      if (!microphoneList.length) {
        this.$darkMessage.warning("当前无可用音频采集设备，无法共享电脑音频");
        this.uploadScreenShareAudioLog(
          "screen_share_audio_no_microphone",
          { source, availableMicrophoneCount: 0 },
          "error"
        );
        return false;
      }
      const micReady = await this.ensureSystemAudioMicDeviceReady(
        source,
        microphoneList
      );
      if (!micReady) {
        return false;
      }
      try {
        await this.liveService.prepareSystemAudioLoopback?.({
          keepBusinessMicMuted: this.userStatus.audio_state !== 1,
        });
        this.uploadScreenShareAudioLog(
          "screen_share_audio_start_local_audio_success",
          { source }
        );
        return true;
      } catch (error) {
        this.$darkMessage.warning("电脑音频共享启动失败，请检查麦克风设备");
        this.uploadScreenShareAudioLog(
          "screen_share_audio_start_local_audio_failed",
          {
            source,
            error: error?.message || error,
          },
          "error"
        );
        return false;
      }
    },
    async ensureSystemAudioMicDeviceReady(source, microphoneList) {
      const currentDeviceId = this.currentMicDevice?.deviceId;
      if (currentDeviceId && currentDeviceId !== "disabled") {
        return true;
      }
      const targetMic =
        microphoneList.find((item) => item.isDefault) || microphoneList[0];
      if (!targetMic?.deviceId || !this.liveService?.setCurrentMicDevice) {
        this.$darkMessage.warning("电脑音频共享启动失败，请检查麦克风设备");
        this.uploadScreenShareAudioLog(
          "screen_share_audio_no_loopback_mic",
          {
            source,
            availableMicrophoneCount: microphoneList.length,
          },
          "error"
        );
        return false;
      }
      try {
        await this.liveService.setCurrentMicDevice({
          deviceId: targetMic.deviceId,
        });
        this.setCurrentMicDevice({
          ...targetMic,
          setFrom: "callback",
        });
        this.uploadScreenShareAudioLog(
          "screen_share_audio_select_loopback_mic",
          {
            source,
            targetMic,
            availableMicrophoneCount: microphoneList.length,
          }
        );
        return true;
      } catch (error) {
        this.$darkMessage.warning("电脑音频共享启动失败，请检查麦克风设备");
        this.uploadScreenShareAudioLog(
          "screen_share_audio_select_loopback_mic_failed",
          {
            source,
            targetMic,
            availableMicrophoneCount: microphoneList.length,
            error: error?.message || error,
          },
          "error"
        );
        return false;
      }
    },
    async getAvailableMicrophoneList(source) {
      let list = this.microphoneList || [];
      if (!list.length && this.liveService?.getMicrophoneList) {
        try {
          list = await this.liveService.getMicrophoneList();
        } catch (error) {
          this.uploadScreenShareAudioLog(
            "screen_share_audio_get_microphone_failed",
            {
              source,
              error: error?.message || error,
            },
            "error"
          );
        }
      }
      return (list || []).filter(
        (item) => item?.deviceId && item.deviceId !== "disabled"
      );
    },
    uploadScreenShareAudioLog(action, extra = {}, level = "info") {
      uploadLiveLog({
        message: "诊断共享电脑音频链路",
        level,
        tag: "screenShareAudio",
        extra: {
          component: "ScreenCaptureSources",
          action,
          pcAudio: this.pcAudio,
          toolBar: this.toolBar,
          screenShareStatus: this.screenShareStatus,
          userAudioState: this.userStatus?.audio_state,
          microphoneCount: this.microphoneList?.length || 0,
          currentMicDevice: this.currentMicDevice,
          availableMicrophoneCount: extra.availableMicrophoneCount,
          targetMicDeviceId: extra.targetMic?.deviceId,
          targetMicDeviceName: extra.targetMic?.deviceName,
          sourceId: extra.source?.sourceId,
          sourceName: extra.source?.sourceName,
          error: extra.error,
        },
      });
    },
    // 不共享当前应用窗口
    excludedShareWindow() {
      const sourceId = window.LiveElectronApi.getCurrentSourceId();
      // const owner = this.allList.find((item) => item.sourceId === sourceId);
      console.log("owner___sourceId", sourceId);
      if (sourceId) {
        this.liveService.addExcludedShareWindow(sourceId);
      }
    },
    // 不共享聊天窗口
    async excludedShareChatWindow() {
      const chatScourceId =
        await window.LiveElectronApi.getChatWindowSourceId();
      console.log("owner___chatScourceId", chatScourceId);
      if (chatScourceId) {
        this.liveService.addExcludedShareWindow(chatScourceId);
      }
    },
    // 设置窗口位置
    setPosition(source) {
      // 获取所有屏幕信息
      // 遍历所有屏幕，判断窗口是否在某个屏幕内
      console.log("djj_source", source);
      console.log("djj_source_desktopList", this.desktopList);
      let screenSource = null;
      for (const type of this.desktopList) {
        if (source.x >= type.x && source.x < type.x + type.width) {
          console.log(`窗口位于屏幕 ${type.sourceName} 上`);
          screenSource = type;

          break;
        }
      }
      if (screenSource) {
        this.atScreen = screenSource;
        window.LiveElectronApi.setPosition(screenSource.x, screenSource.y);
      }
    },
    // 滚动
    handleScroll() {
      const listBox = this.$refs.typeList;
      if (!listBox) return;
      // 检查是否需要显示左右箭头
      const hasHorizontalScroll = listBox.scrollWidth > listBox.clientWidth;
      if (hasHorizontalScroll) {
        this.canScrollLeft = listBox.scrollLeft > 0;
        this.canScrollRight =
          listBox.scrollLeft < listBox.scrollWidth - listBox.clientWidth;
      } else {
        this.canScrollLeft = false;
        this.canScrollRight = false;
      }
    },
    // 展示更多
    handleShowMore(arrow) {
      const scrollDistance = 100;
      if (arrow === "left") {
        this.$refs.typeList.scrollLeft -= scrollDistance;
      } else {
        this.$refs.typeList.scrollLeft += scrollDistance;
      }
    },
    // 创建一个白板然后把这个白板加入一个分组里
    createWhiteGroup() {
      const boardId = this.whiteBoardService.addBoard();
      this.setScreenShareBoardId(boardId);
      // this.whiteBoardService.setClassGroup({
      //   groupId: "screenShare",
      //   boardIds: [boardId],
      //   userIds: [this.userInfo.user_id],
      //   title: "屏幕共享",
      //   currentBoard: boardId,
      // });
      // this.whiteBoardService.setClassGroupEnable(true);
      // console.log("live_white===创建白板组", boardId);
    },
    resetScreenShareBoard() {
      const oldBoardId = this.screenShareBoardId;
      const boardId = this.whiteBoardService.addBoard();
      this.setScreenShareBoardId(boardId);
      if (boardId && this.whiteBoardService.gotoBoard) {
        this.whiteBoardService.gotoBoard(boardId);
      }
      if (oldBoardId && oldBoardId !== boardId) {
        this.whiteBoardService.deleteBoard(oldBoardId);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.comp-container__screen ::v-deep {
  width: 900px;
  height: 640px;
  display: flex;
  flex-direction: column;
  background: #18181b;
  // box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 12px 12px 12px 12px;
  border: 2px solid #27272a;
  .el-drawer__body {
    display: flex;
    flex-direction: column;
  }

  .roster-drawer__title {
    width: 100%;
    height: 48px;
    border-bottom: 1px solid #27272a;
    position: relative;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;

    .close {
      width: 24px;
      height: 24px;
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
      cursor: pointer;

      img {
        width: 24px;
        height: 24px;
      }
    }
  }

  .roster-drawer__content {
    flex: 1;
    padding: 0;
    overflow: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    .loading {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
      backdrop-filter: blur(7px); /* 设置高斯模糊效果 */
      background-color: rgba(0, 0, 0, 0.2); /* 背景颜色 */

      img {
        animation: rotate 2s linear infinite; /* 2秒旋转一圈，匀速，无限循环 */
      }
    }
    .win-list {
      color: #fff;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 10px 32px;
      overflow: auto;
      flex: 1;
      &::-webkit-scrollbar {
        width: 0;
      }
      .list-item {
        cursor: pointer;
        width: 180px;
        height: 133px;
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #27272a;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 30px;
        &.selected {
          background: #072ca6;
        }
        &:hover {
          border-color: #165dff;
          .thumb-box {
            .hover-mask {
              display: flex;
            }
          }
        }
        &.empty {
          height: 0;
          border: none;
          margin-bottom: 0;
        }
        .thumb-box {
          position: relative;
          .thumb {
            border-radius: 10px;
            width: 160px;
            height: 90px;
          }
          .hover-mask {
            display: none;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
            border-radius: 10px 10px 10px 10px;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: 14px;
            color: #ffffff;
          }
        }
        .name {
          padding: 0 12px;
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          line-height: 20px;
          text-align: center;
          margin-top: 6px;
        }
        .icon {
          position: absolute;
          left: -10px;
          top: -10px;
          width: 24px;
          height: 24px;
        }
      }
    }
    .type-list-box {
      display: flex;
      flex-direction: row;
      padding: 24px;
      .arrow {
        width: 40px;
        height: 40px;
        cursor: pointer;
        &.arrow-left {
          margin-right: 10px;
        }
        &.arrow-right {
          margin-left: 10px;
        }
      }
      .list-scroll-box {
        display: flex;
        flex-direction: row;
        flex: 1;
      }
    }
    .type-list {
      flex: 1;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      overflow: auto;
      scroll-behavior: smooth;
      &::-webkit-scrollbar {
        width: 0;
      }
      .list-item {
        width: 40px;
        min-width: 40px;
        height: 40px;
        background: #27272a;
        border-radius: 12px 12px 12px 12px;
        border: 1px solid #27272a;
        margin-right: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
          border-color: #165dff;
        }
        &.selected {
          background: #072ca6;
        }
        .icon {
          width: 24px;
          height: 24px;
          border-radius: 6px 6px 6px 6px;
          &.all {
            background: #165dff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 500;
            font-size: 11px;
            color: #ffffff;
          }
        }
      }
    }
    .select-option {
      padding: 0 23px;
      height: 62px;
      min-height: 62px;
      border-top: 1px solid #27272a;
      display: flex;
      flex-direction: row;
      align-items: center;
      .toolbar-checkbox-hit-area {
        display: inline-flex;
        margin-left: 30px;
      }
      .el-checkbox {
        .el-checkbox__input.is-checked .el-checkbox__inner {
          background: #165dff;
          border-color: #165dff;
        }
        .el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: #165dff;
        }
        .el-checkbox__label {
          color: #ffffff !important;
          padding-left: 2px;
        }
      }
    }
  }
  .preview-box {
    width: 200px;
    height: 200px;
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
